function saveInspectionIssue() {
  var issue_id = $('#protocol-item-modal__issue_id').val().trim();
  var inspection_id = $('#protocol-item-modal__inspection_id').val().trim();

  var title = $('#protocol-item-modal__title').val().trim();
  var categoryId = $('.protocol-category-select__option-button.option-selected').attr('data-id');

  // Validation
  if (!title || !categoryId) {
    if (!title) {
      addTextfieldError('#protocol-item-modal__title');
    }

    if (!categoryId) {
      addSelectfieldError('.protocol-category-select__wrapper');
    }

    animateEl($('#protocol-item-modal__save-button'), 'shake');
    return;
  }

  // Getting values
  var valueContainers = $('.protocol-item-modal__option-content');
  var options = [];

  $.each(valueContainers, function (index, valueContainer) {
    var optionData = $(valueContainer).data('option');

    var valueTitle = optionData.title;
    var valueType = optionData.id ? optionData.value.type : optionData.type;
    var optionValues = optionData.id
      ? optionData.value.values
        ? JSON.parse(optionData.value.values)
        : optionData.value.values
      : optionData.values;
    var value = '';

    switch (valueType) {
      case 'select-one':
        value = $(valueContainer).find('.protocol-item-modal__value-container.value-active').attr('data-value') || null;
        break;

      case 'select-many':
        var activeContainers = $(valueContainer).find('.protocol-item-modal__value-container.value-active');
        value = [];
        $.each(activeContainers, function (index2, activeContainer) {
          value.push($(activeContainer).attr('data-value'));
        });
        break;

      case 'text':
        value = $(valueContainer).find('input').val().trim();
        break;

      case 'number':
        value = $(valueContainer).find('input').val().trim();
        break;
    }

    options.push({
      title: valueTitle,
      type: valueType,
      values: optionValues,
      value: value
    });
  });

  // Create form data
  var formData = new FormData();
  formData.append('id', issue_id);
  formData.append('inspection_id', inspection_id);
  formData.append('title', title);
  formData.append('category_id', categoryId);
  formData.append('options', JSON.stringify(options));

  var fileInput = $('.protocol-item-modal__attachments-form input[type="file"]');

  if (fileInput.length) {
    var files = $('.protocol-item-modal__attachments-form input[type="file"]')[0].files;
    var filesAmount = files.length;

    for (var i = 0; i < filesAmount; i++) {
      formData.append('files[]', files[i]);
    }
  }

  var pushPin = $('#protocol-item-modal__pushpin-button').data('pushpin-data');
  var pushPinData = {
    enabled: pushPin && pushPin.attributes ? 1 : 0,
    data: pushPin
  };
  formData.append('push_pin_data', JSON.stringify(pushPinData));

  var selected_components = $('#protocol-item-modal__components-button').data('selected_components');
  formData.append('selected_components', JSON.stringify(selected_components || []));

  var screenshotData = $('.edit-issue__screenshot-preview').data('screenshot-image');
  if (screenshotData) {
    formData.append('screenshot_data', screenshotData);
  }

  // Send request
  $.ajax({
    url: settings.apiEndpoint + '/api/inspection-item',
    type: 'POST',
    headers: {
      apiToken: settings.apiToken
    },
    data: formData,
    cache: false,
    contentType: false,
    processData: false,
    beforeSend: function () {
      disableIssueForm();
    },
    success: function (response) {
      enableIssueForm();
      if (response && response.success) {
        $('#protocol-item-modal__issue_id').val(response.inspectionItem.id);
        clearFilesToAttach('protocol-item-modal');
        resetButtonLoadingStatus($('#protocol-item-modal__save-button'), __('saveButton'));

        var issueButton = getIssueButton(app.selectedInspection, response.inspectionItem);
        var currentIssueButton = $('.issue-button__wrapper[data-id="' + response.inspectionItem.id + '"]');

        $(
          '.category-issues__issues-wrapper[data-id="' +
            response.inspectionItem.protocol_category_id +
            '"] .category-issues__no-issues'
        ).remove();

        // Update button
        if (currentIssueButton.length) {
          var currentCategoryId = currentIssueButton.parents('.category-issues__issues-wrapper').attr('data-id');
          if (currentCategoryId != response.inspectionItem.protocol_category_id) {
            currentIssueButton.remove();
            $(
              '.category-issues__issues-wrapper[data-id="' + response.inspectionItem.protocol_category_id + '"]'
            ).append(issueButton);
          } else {
            currentIssueButton.replaceWith(issueButton);
          }
          // Add button
        } else {
          $('.category-issues__issues-wrapper[data-id="' + response.inspectionItem.protocol_category_id + '"]').append(
            issueButton
          );
        }

        // currentIssueButton.data('pushpin-data', pushPin);

        // Close modal
        app.protocolItemModal.close();

        success(__('issueSaveSuccessNotice'));
        return;
      }

      animateEl($('#protocol-item-modal__save-button'), 'shake');
      error();
    },
    error: function () {
      enableIssueForm();
      resetButtonLoadingStatus($('#protocol-item-modal__save-button'), 'Save');
      animateEl($('#protocol-item-modal__save-button'), 'shake');
      error();
    },
    xhr: function () {
      var myXhr = $.ajaxSettings.xhr();
      if (myXhr.upload) {
        myXhr.upload.addEventListener(
          'progress',
          function (e) {
            if (e.lengthComputable) {
              // console.log(e.loaded, e.total);
              const button = $('#protocol-item-modal__save-button');
              const percent = Math.floor((e.loaded / e.total) * 100);
              const text =
                'Uploading files (' + formatBytes(e.loaded, 2) + ' / ' + formatBytes(e.total, 2) + ') ' + percent + '%';
              setButtonLoadingStatus(button, text, percent);
            }
          },
          false
        );
      }
      return myXhr;
    }
  });
}

function disableIssueForm() {
  $('#protocol-item-modal__save-button').attr('disabled', 'disabled').addClass('loading-bar');
}

function enableIssueForm() {
  $('#protocol-item-modal__save-button').removeAttr('disabled').removeClass('loading-bar');
}

// Add an inspection category with issues

function getCategoriesWithIssueButtons(inspection) {
  if (!inspection || !inspection.protocol || !inspection.protocol.categories) {
    return '';
  }

  var categoriesWrapper = $('<div class="category-issues__categories-wrapper"/>');

  $.each(inspection.protocol.categories, function (index, category) {
    if (!category.active) {
      return;
    }
    var categoryWrapper = $('<div class="category-issues__category-wrapper"/>').appendTo(categoriesWrapper);

    categoryWrapper.append($('<div class="category-issues__category-title"/>').html(category.title));

    var categoryIssuesWrapper = $('<div class="category-issues__issues-wrapper"/>')
      .attr('data-id', category.id)
      .appendTo(categoryWrapper);

    if (category.items && category.items.length) {
      $.each(category.items, function (index2, issue) {
        categoryIssuesWrapper.append(getIssueButton(inspection, issue));
      });
    } else {
      categoryIssuesWrapper.append(
        $('<div class="category-issues__no-issues panel__empty"/>').html(__('issueNoticeNoIssuesInCategory'))
      );
    }
  });

  return categoriesWrapper;
}

// Get the issue button element

function getIssueButton(inspection, issue) {
  var wrapper = $('<div class="issue-button__wrapper"/>')
    .attr('data-id', issue.id)
    // .data('pushpin-data', issue.push_pin_data)
    .on('click', function () {
      openInspectionItemModal(inspection, issue);
    });

  wrapper.html(issue.title);

  return wrapper;
}
